import { ApplicationError } from './application.error';

export class ClientProcessingError extends ApplicationError {
  constructor(message: string, originalError: any = null) {
    super(
      'ClientProcessingError',
      message,
      'We could not process the data returned by the server. Please contact support if the problem continues.',
      originalError
    );
  }
}
